import { Contact } from '@features/contacts/types/contact'
import { Account } from '@modules-deprecated/app/accounts/types'

export const getAccountFromContact = (accounts: Account[], contact?: Partial<Contact>): Account | undefined => {
  if (!contact || !contact.defaultExpenseAccountId) {
    return
  }
  return accounts.find(({ id }) => id === contact.defaultExpenseAccountId)
}
